/** Row click on a revision: that press's saved membership, pinned so it is never re-resolved against today. */
import { Injector, runInInjectionContext } from '@angular/core';
import { VisitApprovalRevisionRow } from '@jms/model';
import { injectDialog } from '@workbuddy/ui/v2/blocks/dialog';
import { ApprovalRevisionsBoardParams } from '../visit.approval.detail.model';

export async function openApprovalRevision(injector: Injector, params: ApprovalRevisionsBoardParams, row: VisitApprovalRevisionRow): Promise<void> {

  const { ApprovalRevisionComponent } = await import('../dialog/revision/approval.revision.component');
  await runInInjectionContext(injector, injectDialog).modal(ApprovalRevisionComponent, {
    width: 'min(1100px, calc(100vw - 40px))',
    height: 'min(760px, calc(100vh - 40px))',
    inputs: { approval: params.approval, scope: params.scope, revision: row.record },
    aria: { label: `Approval revision ${row.revision}` },
  });
}
